import { defineComponent as r, openBlock as o, createBlock as l, unref as p, mergeProps as c, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconArrowUpLeftInCircle",
  __name: "IconArrowUpLeftInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (s, t) => (o(), l(p(i), c(n, { "view-box": "0 0 24 24" }), {
      default: m(() => [...t[0] || (t[0] = [
        e("path", { d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0m1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75" }, null, -1),
        e("path", { d: "M9.53 8.47a.75.75 0 0 0-1.06 1.06l6 6a.75.75 0 0 0 1.06-1.06l-6-6" }, null, -1),
        e("path", { d: "M13.707 9.386a.75.75 0 0 0 0-1.5H9.136a1.25 1.25 0 0 0-1.25 1.25v4.571a.75.75 0 1 0 1.5 0V9.386h4.321" }, null, -1),
        e("path", { d: "M13.707 7.886a.75.75 0 0 1 0 1.5h-3.26l5.083 5.084a.75.75 0 1 1-1.06 1.06l-5.084-5.084v3.261a.75.75 0 1 1-1.5 0V9.136a1.25 1.25 0 0 1 1.25-1.25h4.571" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
